import { makeRouter } from '@adornis/router/client/make-router.js';
import { html } from 'lit';
import * as m from '../../../../localization/out/messages.js';
import { pageTitle } from '../../page-title.js';
import { RegisterDashboard } from './register-dashboard.js';
import { RegisterJobDetail } from './register-job-detail.js';
import { RegisterRegister } from './register-register.js';

export const registerRouter = makeRouter({
  root: {
    path: '/',
    documentTitlePart: pageTitle(m.menuJobPosting),
    render: () => RegisterDashboard(),
  },
  register: {
    path: '/register{/*}?*',
    documentTitlePart: pageTitle(m.apply_button),
    render: () => RegisterRegister(),
  },
  jobDetail: {
    path: '/job/:jobPositionID',
    documentTitlePart: pageTitle(m.page_title_job),
    render: params =>
      params.jobPositionID ? RegisterJobDetail({ jobPositionID: params.jobPositionID }) : html`${m.page_not_found()}`,
  },
});
